import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { component as spContext } from '@cred/react-analytics/contexts'
import { SnowplowContext } from '@cred/react-analytics/SnowplowContextManager'

import ViewportAnalytics from 'components/viewport-analytics'
import ViewportController from 'components/viewport-controller'
import WidgetContext from 'components/widget-context'
import InitialValuesContext from 'components/initial-values-context'

import { getContexts } from './utils'

const WidgetPage = (WrappedComponent) => (props) =>
  <HOC {...props} WrappedComponent={WrappedComponent} />

const HOC = (props) => {
  const { WrappedComponent } = props
  const { initialValues } = useContext(InitialValuesContext)
  const widgetContext = useContext(WidgetContext)

  const {
    options: {
      ui: { theme },
      product: { variation, type, marketplace, customCTA },
      meta: {
        contentId,
        articleTitle,
        articleTags,
        segmentId,
        campaignCode,
        contentDistributor,
        contentCategory,
        campaignCodeExt,
      } = {},
      analytics,
      ...options
    },
    parentPage: { partnerReferrer, partnerDomain, partnerURL },
    credclid,
    renderId,
    source = analytics ? analytics.source : null,
    campaignFromPageUrl,
  } = widgetContext

  const finalSource = source || partnerDomain || 'undefined'
  let url = ''

  if (partnerURL) {
    ;[url] = partnerURL.split('?')
  }

  const showRateTableAsFirstPrequalStep = type === 'rate-table-with-embedded-prequal'

  return (
    <ViewportController>
      {({ size, position, seen }) => (
        <SnowplowContext
          contexts={getContexts({
            source: finalSource,
            partnerUrl: url,
            partnerReferrer,
            variation,
            type,
            marketplace,
            size,
            position,
            credclid,
            renderId,
            contentId,
            articleTitle,
            articleTags,
            segmentId,
            campaignCode,
            contentDistributor,
            contentCategory,
            campaignCodeExt,
          })}
        >
          <ViewportAnalytics seen={seen} position={position} size={size} />
          <WrappedComponent
            {...props}
            key={`${marketplace}#${type}`}
            theme={theme}
            variation={variation}
            customCTA={customCTA}
            uniqueId={options.uniqueId}
            widgetContext={widgetContext}
            initialValues={initialValues}
            verticals={marketplace}
            type={type}
            omitUtmParams={options.omitUtmParams}
            showRateTableAsFirstPrequalStep={showRateTableAsFirstPrequalStep}
            metaParams={{
              articleTitle,
              articleTags,
              contentId,
              contentCategory,
              contentDistributor,
              campaignCode,
              campaignCodeExt,
              pageUrl: partnerURL,
              segmentId,
            }}
            utms={{
              utm_campaign: campaignFromPageUrl || url,
              utm_medium: 'partner_integration',
              utm_source: finalSource,
              utm_content: options.uniqueId || '',
              credclid,
              renderId,
            }}
            analyticsContexts={[spContext.analytics({ name: `${marketplace}#${type}` })]}
          />
        </SnowplowContext>
      )}
    </ViewportController>
  )
}

HOC.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
}

export default WidgetPage
